import { FaSearch, FaLightbulb, FaTools, FaChartBar, FaRocket } from "react-icons/fa";

export default function SectionSeoProcess() {
  const steps = [
    {
      title: "Audit",
      text: "We perform an in-depth audit of your website, competitors, and keywords to identify key opportunities for growth.",
      icon: <FaSearch className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Strategy",
      text: "We build a tailored SEO strategy that aligns with your business goals and target audience.",
      icon: <FaLightbulb className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Implementation",
      text: "We implement technical fixes, optimize content, and start link-building efforts.",
      icon: <FaTools className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Reporting",
      text: "Track improvements in traffic, leads, and salesTrack improvements in rankings, traffic, and conversions with detailed, transparent reporting.",
      icon: <FaChartBar className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    },
    {
      title: "Growth",
      text: "We continue optimizing, scaling, and refining your SEO strategy to ensure sustained growth.",
      icon: <FaRocket className="w-12 h-12 md:w-16 md:h-16 text-[#DA2128]" />
    }
  ];

  return (
    <div className="SectionSeoProcess py-[60px] md:py-[100px] bg-white">
      <div className="text-center mb-16 max-w-4xl mx-auto">
        <h2 className="text-[28px] md:text-[36px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
          How Mean3 Delivers SEO Success in the UAE
        </h2>
        <h3 className="mt-6 text-[28px] md:text-[30px] max-w-[600px] mx-auto text-[red] text-bold">
          Our SEO Process
        </h3>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-12 md:gap-16 w-[90%] md:w-[85%] mx-auto">
        {steps.map((step, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center transition transform hover:-translate-y-2 hover:scale-105 duration-300"
          >
            <div className="mb-4">{step.icon}</div>
            <h3 className="text-[18px] md:text-[20px] font-semibold text-[#151515]">
              {step.title}
            </h3>
            <p className="mt-2 text-gray-600 text-sm md:text-base">{step.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
